<template>
  <div class="qr-code-page">
    <div class="row">
      <div class="col d-flex align-items-center">
        <div class="text-left">
          <h3 class="mb-1 qr-code-title">Report QR Code</h3>
        </div>
      </div>

      <div class="text-right" style="min-width: 200px; width: 50%">
        <div class="col row" style="display: flex; justify-content: flex-end">
          <div class="col-md-6">
            <div class="input-group" style="width: 100%">
              <div class="input-group-prepend" style="height: 43px">
                <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown"
                  aria-haspopup="true" aria-expanded="false" style="
                    background-color: #ffffff;
                    border-color: #e8e8e8;
                    color: #4b4b4b;
                    font-weight: 500;
                    font-family: 'Inter', sans-serif;
                  ">
                  {{
                    options.searchFilter.find(
                      (x) => x.value == filter.search_by
                    ).text
                  }}&nbsp;<img src="@/assets/img/multiselect-chevron.svg" alt="Dropdown"
                    style="width: 7px; height: 4px; vertical-align: middle; margin-left: 4px;" />
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" v-for="opt in options.searchFilter" @click="filter.search_by = opt.value">{{
                    opt.text }}</a>
                </div>
              </div>
              <input v-model="filter.search" type="text" class="form-control search-type-input"
                aria-label="Text input with dropdown button" :placeholder="'Type ' +
                  options.searchFilter.find((x) => x.value == filter.search_by)
                    .text
                  " />
            </div>
          </div>
          <div class="col-md-3">
            <MultiSelect v-model="filter.status" :options="options.status" label="label" track-by="value" select-label="" deselect-label="" selected-label=""></MultiSelect>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white box-content mt-4 scan-history-table-wrapper">
      <div v-if="tableLoading" class="text-center mt-3 mb-3">
        <h4>Loading...</h4>
      </div>

      <div v-else style="overflow-x: auto; overflow-y: hidden">
        <table class="table scan-history-table" style="margin: 0">
          <thead>
            <tr>
              <th style="padding-left: 20px; padding-top: 20px;">QR Code</th>
              <th style="padding-top: 20px;">Serial</th>
              <th style="padding-top: 20px;">Status</th>
              <th class="sortable" @click="toggleSort('created_at')" style="user-select: none; padding-top: 20px;">
                <span>Created At</span>
                <img v-if="sortBy === 'created_at'" src="@/assets/img/table-sort.svg" alt="Sort" class="ml-1 sort-icon"
                  :style="{
                    height: '14px',
                    width: 'auto',
                    verticalAlign: 'middle',
                    transform: sortOrder === 'asc' ? 'rotate(180deg)' : 'none'
                  }" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in tableData" :key="`${row.id || row.qrcode || index}-${index}`">
              <td style="padding-left: 20px;">{{ row.qrcode || "-" }}</td>
              <td>{{ row.serial_number || "-" }}</td>
              <td :style="statusStyle(row.status)">
                {{ displayStatus(row.status) }}
              </td>
              <td>{{ formatDate(row.created_at) }}</td>
            </tr>
            <tr v-if="!tableLoading && tableData.length === 0">
              <td colspan="4" class="text-center">No data available</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="row mt-3 pagination-divider"
        v-if="!tableLoading && (tableData.length > 0 || total > 0 || maxPage > 1)">
        <div class="col-12 d-flex align-items-center justify-content-between flex-wrap mb-3 pl-3">
          <div class="d-flex align-items-center">
            <span class="view-per-page-text"
              style="margin-right: 8px; color: #CBCBCB; font-size: 14px; font-weight: 400; font-style: normal;">
              View
            </span>
            <select v-model.number="limitPerPage" @change="onLimitChange" class="form-control form-control-sm"
              style="width: auto; display: inline-block; padding: 4px 8px; font-family: 'Inter', sans-serif;">
              <option v-for="option in limitPerPageOptions" :key="option" :value="option">
                {{ option }}
              </option>
            </select>
            <span class="view-per-page-text"
              style="margin-left: 8px; color: #CBCBCB; font-size: 14px; font-weight: 400; font-style: normal;">
              items per page
            </span>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <p class="mt-2 mb-2 view-per-page-text"
              style="color: #CBCBCB; margin-right: 20px; font-size: 14px; font-weight: 400; font-style: normal;">
              Showing Page {{ currentPage }}
            </p>
            <nav class="pagination-minimal">
              <ul class="pagination" style="margin: 0; flex-wrap: wrap">
                <li class="page-item" :class="{ disabled: currentPage <= 1 || tableLoading }"
                  @click.stop.prevent="changePage('prev')">
                  <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                </li>
                <li class="page-item" :class="{
                  disabled:
                    tableLoading ||
                    (!hasMoreData && currentPage >= maxPage && maxPage !== 0),
                }" @click.stop.prevent="changePage('next')">
                  <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import moment from "moment";

export default {
  metaInfo: {
    title: "Report QR Code",
  },
  data() {
    const searchFilterOptions = [
      { text: "QR Code", value: "qrcode" },
      { text: "Serial Number", value: "serial_number" },
    ];
    const statusOptions = [
      { label: "ACTIVE", value: "ACTIVE" },
      { label: "INACTIVE", value: "INACTIVE" },
      { label: "DEACTIVATED", value: "DEACTIVATED" },
    ];

    return {
      modal: {
        detail: false,
        detailId: null,
      },

      options: {
        searchFilter: searchFilterOptions,
        status: statusOptions,
      },
      filter: {
        search: "",
        search_by: "qrcode",
        status: [statusOptions[0]],
      },
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      maxPage: 1,
      total: 0,
      limitPerPage: 10,
      limitPerPageOptions: [10, 25, 50, 100],
      sortBy: "created_at",
      sortOrder: "desc",
      fetchDataTimer: null,
    };
  },
  computed: {
    hasMoreData() {
      return this.tableData.length === this.limitPerPage;
    },
  },
  watch: {
    "filter.search"(newVal, oldVal) {
      if ((newVal || "").trim() === (oldVal || "").trim()) return;
      this.scheduleFetch();
    },
    "filter.search_by"(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.scheduleFetch(true);
    },
    "filter.status": {
      handler(newVal, oldVal) {
        const newValString = this.serializeStatusFilter(newVal, true);
        const oldValString = this.serializeStatusFilter(oldVal, true);
        if (newValString === oldValString) return;
        this.scheduleFetch(true);
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchData(true);
  },
  beforeDestroy() {
    if (this.fetchDataTimer) {
      clearTimeout(this.fetchDataTimer);
    }
  },
  methods: {
    scheduleFetch(immediate = false) {
      this.currentPage = 1;
      if (this.fetchDataTimer) {
        clearTimeout(this.fetchDataTimer);
      }
      if (immediate) {
        this.fetchData(true);
        return;
      }
      this.fetchDataTimer = setTimeout(() => {
        this.fetchData(true);
      }, 300);
    },
    async fetchData(resetPage = false) {
      if (resetPage) {
        this.currentPage = 1;
      }

      const params = {
        search_by: this.filter.search_by,
        limit: this.limitPerPage,
        page: this.currentPage,
        order: this.sortOrder,
        by: this.sortBy,
      };

      if (this.filter.search && this.filter.search.trim()) {
        params.search = this.filter.search.trim();
      }

      const statusFilter = this.serializeStatusFilter(this.filter.status);
      if (statusFilter) {
        params.status = statusFilter;
      }

      const queryString = qs.stringify(params, {
        skipNulls: true,
        encodeValuesOnly: true,
      });

      this.tableLoading = true;

      try {
        const resp = await this.$http.get(`/qrcode-report?${queryString}`);
        const data =
          (resp && resp.data && resp.data.data) ||
          (resp && resp.data && resp.data.rows) ||
          [];
        const meta =
          (resp && resp.data && resp.data.meta) ||
          (resp && resp.data && resp.data.pagination) ||
          resp.data ||
          {};

        this.tableData = Array.isArray(data) ? data : [];
        this.currentPage =
          meta.currentPage ||
          meta.current_page ||
          meta.page ||
          this.currentPage;
        this.maxPage =
          meta.lastPage ||
          meta.last_page ||
          meta.totalPages ||
          meta.total_pages ||
          (this.tableData.length === this.limitPerPage
            ? this.currentPage + 1
            : this.currentPage);
        this.total = meta.total || meta.totalItems || meta.total_count || 0;
      } catch (error) {
        console.error("Failed to fetch QR code report:", error);
        this.tableData = [];
        this.currentPage = 1;
        this.maxPage = 1;
        this.total = 0;
      } finally {
        this.tableLoading = false;
      }
    },
    onLimitChange() {
      this.currentPage = 1;
      this.fetchData();
    },
    changePage(direction) {
      if (this.tableLoading) return;

      if (direction === "prev" && this.currentPage > 1) {
        this.currentPage -= 1;
        this.fetchData();
        return;
      }

      const hasNextPage =
        this.hasMoreData || (this.maxPage && this.currentPage < this.maxPage);

      if (direction === "next" && hasNextPage) {
        this.currentPage += 1;
        this.fetchData();
      }
    },
    toggleSort(column) {
      if (column === "created_at") {
        if (this.sortBy === column) {
          this.sortOrder = this.sortOrder === "desc" ? "asc" : "desc";
        } else {
          this.sortBy = column;
          this.sortOrder = "desc";
        }
        this.fetchData(true);
      }
    },
    formatDate(value) {
      if (!value) {
        return "-";
      }
      const parsed = moment(value);
      if (!parsed.isValid()) {
        return value;
      }
      return parsed.format("DD/M/YYYY - HH:mm:ss");
    },
    statusStyle(status) {
      switch (status) {
        case "ACTIVE":
          return "color: #34ce4c; font-weight: 400; font-style: normal; font-family: 'Inter', sans-serif;";
        case "INACTIVE":
          return "color: #cd2e2c; font-weight: 400; font-style: normal; font-family: 'Inter', sans-serif;";
        case "DEACTIVE":
        case "DEACTIVATED":
          return "color: #F2A93C; font-weight: 400; font-style: normal; font-family: 'Inter', sans-serif;";
        default:
          return "font-weight: 400; font-style: normal; font-family: 'Inter', sans-serif;";
      }
    },
    displayStatus(status) {
      switch (status) {
        case "ACTIVE":
          return "Active";
        case "INACTIVE":
          return "Inactive";
        case "DEACTIVE":
        case "DEACTIVATED":
          return "Deactivated";
        default:
          return status || "-";
      }
    },
    serializeStatusFilter(value, sortValues = false) {
      const normalize = (entry) => {
        if (!entry) return "";
        if (typeof entry === "string") return entry;
        if (typeof entry === "object" && entry.value) return entry.value;
        return "";
      };

      if (Array.isArray(value)) {
        const mapped = value.map(normalize).filter(Boolean);
        const ordered = sortValues ? mapped.sort() : mapped;
        return ordered.join(",");
      }

      if (typeof value === "string") {
        return value;
      }

      if (typeof value === "object" && value !== null) {
        return normalize(value);
      }

      return "";
    },
  },
};
</script>

<style>
.qr-code-page {
  font-family: "Inter", sans-serif !important;
}

.qr-code-page * {
  font-family: "Inter", sans-serif !important;
}

.qr-code-page h3,
.qr-code-page h4 {
  font-family: "Inter", sans-serif !important;
}

.qr-code-page .btn {
  font-family: "Inter", sans-serif !important;
}

.qr-code-title {
  font-size: 16px;
  line-height: 24px;
  color: #4b4b4b;
}

.qr-code-page .form-control,
.qr-code-page input,
.qr-code-page select {
  font-family: "Inter", sans-serif !important;
}

.qr-code-page .dropdown-menu,
.qr-code-page .dropdown-item {
  font-family: "Inter", sans-serif !important;
  color: #4b4b4b;
}

.view-per-page-text {
  font-family: "Inter", sans-serif !important;
  color: #CBCBCB;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
}

.scan-history-table-wrapper.box-content {
  padding: 0;
}

/* MultiSelect Chevron Icon */
.qr-code-page .multiselect {
  position: relative;
  display: inline-block;
  width: 100%;
}

.qr-code-page .multiselect__single,
.qr-code-page .multiselect__placeholder,
.qr-code-page .multiselect__input,
.qr-code-page .multiselect__tags {
  color: #4b4b4b;
}

.qr-code-page .multiselect__select {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 100%;
  padding: 0;
  margin: 0;
  text-align: center;
  border-left: none;
  z-index: 1;
}

.qr-code-page .multiselect__select:before {
  display: none !important;
}

.qr-code-page .multiselect__select:after {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 7px;
  height: 4px;
  background-image: url("~@/assets/img/multiselect-chevron.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  pointer-events: none;
  transition: transform 0.2s ease;
}

.qr-code-page .multiselect--active .multiselect__select:after {
  transform: translateY(-50%) rotate(180deg);
}

.qr-code-page .multiselect__tags {
  padding-right: 40px;
}
</style>

<style scoped>
.box-content {
  border-radius: 10px;
}

.pagination-divider {
  border-top: 1px solid #e6e6e6;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 16px;
  overflow: hidden;
}

.table td,
.table th {
  text-align: left;
  vertical-align: middle;
}

.search-type-input {
  height: 43px;
  border-color: #e8e8e8;
  border-left: none;
  color: #c9c9c9;
  font-family: "Inter", sans-serif !important;
}

.search-type-input::placeholder {
  color: #c9c9c9;
  opacity: 1;
}

.search-type-input:focus {
  border-color: #e8e8e8;
  box-shadow: none;
}

.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
  font-family: "Inter", sans-serif !important;
  table-layout: fixed;
  width: 100%;
}

.scan-history-table-wrapper .scan-history-table th,
.scan-history-table-wrapper .scan-history-table td {
  width: 25%;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffffff !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9d9d9d;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table thead th.sortable {
  cursor: pointer;
}

.scan-history-table-wrapper .scan-history-table thead th .sort-icon {
  font-size: 12px;
  color: #4b4b4b;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4b4b4b;
  text-align: left;
  vertical-align: middle;
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
  padding-top: 15px;
  padding-bottom: 15px;
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4b4b4b;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  font-family: "Inter", sans-serif !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled) .page-link:hover {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9d9d9d !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}
</style>